// Shared site content & constants for Se Klart Ut
export const SITE = {
  name: "Se Klart Ut",
  tagline: "Fönsterputs & utvändig rengöring",
  city: "Skövde",
  phone: "072-448 39 09",
  phoneHref: "tel:+46724483909",
  email: "info@seklartut.se",
  emailHref: "mailto:info@seklartut.se",
  instagram: "https://www.instagram.com/seklartut",
  tiktok: "https://www.tiktok.com/@seklartut",
};

export const IMAGES = {
  logo: "https://customer-assets.emergentagent.com/job_se-klart-ut/artifacts/9shpgbwa_IMG_4194.jpeg",
  worker: "https://customer-assets.emergentagent.com/job_se-klart-ut/artifacts/uqc5mf4q_IMG_4322.jpeg",
  heroWindow: "https://customer-assets-jt897jd0.emergentagent.net/job_se-klart-ut/artifacts/f43pmhej_IMG_0940.webp",
  workOne: "https://customer-assets-jt897jd0.emergentagent.net/job_se-klart-ut/artifacts/as7zs7v9_IMG_0167.jpeg",
  workTwo: "https://customer-assets-jt897jd0.emergentagent.net/job_se-klart-ut/artifacts/9i18jhpt_IMG_0168.jpeg",
  beforeUterum: "https://customer-assets-jt897jd0.emergentagent.net/job_se-klart-ut/artifacts/5okjdw8g_IMG_0935.jpeg",
  afterUterum: "https://customer-assets-jt897jd0.emergentagent.net/job_se-klart-ut/artifacts/dnoshd9c_IMG_0934.jpeg",
  houseWindows: "https://images.unsplash.com/photo-1613490493576-7fde63acd811?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxjbGVhbiUyMHdpbmRvdyUyMGdsYXNzJTIwYXJjaGl0ZWN0dXJhbCUyMG1vZGVybiUyMGhvdXNlJTIwd2luZG93JTIwd2FzaGluZ3xlbnwwfHx8fDE3OTExOTE0NDd8MA&ixlib=rb-4.1.0&q=85",
};

export const NAV = [
  { label: "Tjänster", to: "#tjanster" },
  { label: "Så fungerar det", to: "#sa-fungerar-det" },
  { label: "Om oss", to: "#om-oss" },
  { label: "Referenser", to: "#referenser" },
  { label: "Vanliga frågor", to: "#vanliga-fragor" },
];

// Main window-cleaning levels — exactly 3. "Mellan fönstren" is an add-on, never a level.
export const FP_LEVELS = [
  {
    id: "utsida",
    name: "Utsida",
    short: "Skinande ren utsida – klart och streckfritt.",
    detail: "Alla utvändiga glas putsas noggrant. Perfekt för dig som vill ha rena fönster från gatan.",
  },
  {
    id: "in-och-utsida",
    name: "In och utsida",
    short: "Kristallklara fönster på båda sidor – härligt ljusinsläpp.",
    detail: "Vi putsar både insida och utsida så att ljuset flödar in ordentligt.",
  },
  {
    id: "premium",
    name: "Premium",
    badge: "Populärast",
    short: "Komplett putsning in- och utvändigt, inklusive noggrann rengöring av fönsterkarmar.",
    detail: "Den kompletta behandlingen – in- och utsida plus omsorgsfull rengöring av fönsterkarmarna. För dig som vill ha det där lilla extra.",
  },
];

export const OTHER_SERVICES = [
  { id: "solpaneltvatt", label: "Solpaneltvätt", short: "Rena paneler som fångar mer energi." },
  { id: "altantvatt",    label: "Altantvätt",    short: "Fräscha upp altanen inför säsongen." },
  { id: "marktvatt",     label: "Marktvätt",     short: "Uppfarter och gångar som känns nya." },
];

export const TESTIMONIALS = [
  { name: "Anna L.", area: "Skövde", text: "Helt fantastiskt resultat! Fönstren är skinande rena utan ett enda streck. Trevligt bemötande och punktliga. Rekommenderas varmt!", rating: 5 },
  { name: "Johan M.", area: "Skultorp", text: "Bokade abonnemang för villan och har aldrig haft renare fönster. Man ser verkligen skillnaden – det ljusnar upp hela huset.", rating: 5 },
  { name: "Sara & Erik", area: "Tibro", text: "Kostnadsfri offert, tydligt pris och ett resultat som överträffade förväntningarna. Se Klart Ut-garantin gav extra trygghet.", rating: 5 },
];

// Shared session key: configurator selection carried into the booking page
export const SELECTION_KEY = "sku-selection";
